var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 5H8.33268V10H6.66602V3.33333H11.666V0H4.99935V5H3.33268C2.41602 5 1.66602 5.75 1.66602 6.66667V16.6667C1.66602 17.5833 2.41602 18.3333 3.33268 18.3333H16.666C17.5827 18.3333 18.3327 17.5833 18.3327 16.6667V6.66667C18.3327 5.75 17.5827 5 16.666 5Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipCode);
export default __webpack_public_path__ + "static/media/zip-code.a23ff18d89f23de7cb01a50b8d2a9135.svg";
export { ForwardRef as ReactComponent };